import React, { useState } from 'react'
import { fetchBookingBalance } from '@/utils/apiEndpoints'
import { PrimaryButton } from '@/style-guide'
import common from '@/utils/common'
import { Button } from 'antd'

export const BalancePayment = ({ bookingData, loadPaymentDetails }) => {
  const [loading, setLoading] = useState(false)
  const payBalance = async (cardDetails) => {
    try {
      setLoading(true)
      await fetchBookingBalance(bookingData._id, cardDetails)
      loadPaymentDetails()
      common.successToast(
        'The partial payment has been successfully processed. Thank you for your payment.'
      )
    } catch (e) {
      common.errorToast(
        'We’ve encountered an unexpected error. Please try again and contact us at hello@tripsha.com if the error persists.'
      )
    } finally {
      setLoading(false)
    }
  }

  return (
    <Button
      type="primary"
      disabled={loading}
      onClick={() => {
        payBalance(bookingData.stripePaymentMethod)
      }}
    >
      Pay Balance
    </Button>
  )
}
